// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1O660","sectionsWrapper":"style_sectionsWrapper__YgRSR","tableWrapper":"style_tableWrapper__18SWP","tableTitle":"style_tableTitle__3-A5h"};